import type { WeightedCenterAction } from './weightedCenter.action';
import {
  weightedCenterClearSelectedEntities, weightedCenterOnResultsError, weightedCenterSetResults, weightedCenterSetSelectedEntities,
  weightedCenterSetWeightColumnId,
} from './weightedCenter.actionCreators';
import type { WeightedCenterState } from './weightedCenter.state';

const initialState: WeightedCenterState = {
  selectedEntities: {
    boundaries: [],
    boundaryTerritories: [],
    proximities: [],
  },
  weightColumnId: null,
  results: {
    isError: false,
    isLoading: true,
    data: [],
    weightedCenter: null,
  },
};

export const weightedCenterReducer = (state = initialState, action: WeightedCenterAction): WeightedCenterState => {
  if (weightedCenterSetSelectedEntities.match(action)) {
    return {
      ...state,
      selectedEntities: {
        ...initialState.selectedEntities,
        ...action.payload.newSelectedEntities,
      },
      results: initialState.results,
    };
  }

  if (weightedCenterClearSelectedEntities.match(action)) {
    return initialState;
  }

  if (weightedCenterSetResults.match(action)) {
    return {
      ...state,
      results: {
        isError: false,
        isLoading: false,
        data: action.payload.data,
        weightedCenter: action.payload.center,
      },
    };
  }

  if (weightedCenterOnResultsError.match(action)) {
    return {
      ...state,
      results: {
        ...state.results,
        isError: true,
        isLoading: false,
      },
    };
  }

  if (weightedCenterSetWeightColumnId.match(action)) {
    return {
      ...state,
      results: initialState.results,
      weightColumnId: action.payload.weightColumnId,
    };
  }

  return state;
};
